import {
  CLEAR_GROUP_CREATE_GATE,
  POST_CREATE_GROUP_DOMAIN_BLOCKED,
  POST_CREATE_GROUP_SIMILAR_GROUPS,
  POST_CREATE_GROUP_SUCCESS
} from '../actions/groupActions'

const initialState = {
  status: 'idle',
  similarGroups: [],
  pendingPayload: null,
  responseJSON: null
}

export default (state = initialState, { type, data = {} }) => {
  switch (type) {
    case POST_CREATE_GROUP_SIMILAR_GROUPS:
      return {
        ...initialState,
        status: 'similar_groups',
        similarGroups: data.similarGroups || [],
        pendingPayload: data.pendingPayload || null
      }
    case POST_CREATE_GROUP_DOMAIN_BLOCKED:
      return {
        ...initialState,
        status: 'domain_blocked',
        responseJSON: data.responseJSON || null
      }
    case CLEAR_GROUP_CREATE_GATE:
    case POST_CREATE_GROUP_SUCCESS:
      return initialState
    default:
      return state
  }
}
